/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { selectAuth, selectOrder } from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { handleApiError } from '@/utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const fetcher = (url: any, invoiceID: string) => {
  const response = axios({
    method: 'post',
    url: `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.refund_sales_invoice?invoice_id=${invoiceID}`,
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useRefundInvoice = () => {
  const { url } = useSelector(selectAuth);
  const navigate = useNavigate();
  const { current_invoice } = useSelector(selectOrder);
  const dispatch = useDispatch();

  const handleSuccess = () => {
    dispatch(
      setAlert({ type: 'success', message: 'Customer refunded successfully!' }),
    );
    navigate('/tables');
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
  };

  const mutate = useMutation(() => fetcher(url, current_invoice), {
    onSettled: (data) => {
      if (!data.data) {
        const errorMessage = handleApiError(data);
        handleError(errorMessage);
      } else if (data.data) {
        handleSuccess();
      }
    },
    onError: () => handleError('An Error Occured. Contact Administration'),
  });

  return mutate;
};
